import HeroSection from '../components/homepage/HeroSection';
import Navbar from '../components/homepage/Navbar';
import TrustBar from '../components/homepage/TrustBar';
import Services from '../components/homepage/Services';
import HowItWorks from '../components/homepage/HowItWorks';
import FeaturedPlans from '../components/homepage/FeaturedPlans';
import Testimonials from '../components/homepage/Testimonials';
import ContactUs from '../components/homepage/ContactUs';
import Footer from '../components/homepage/Footer';

function Homepage() {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <TrustBar />
      <Services />
      <HowItWorks />
      <FeaturedPlans />
      <Testimonials />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default Homepage;
